import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './Veneers.css';

const Veneers = () => {
    const pricing = [
        { type: "Direct Composite", price: "₱6,000" },
        { type: "Indirect Composite", price: "₱10,000" },
        { type: "Indirect Porceline", price: "₱18,000 UP" },
    ];

    return (
        <>
        <Header />

        <div className="veneers-container">
            
            <div className="veneers-content">
                <h1>VENEERS</h1>
                <p>
                Dental veneers are thin, custom-made shells that are bonded to the front surface 
                of teeth to improve their appearance. They 1  can correct a variety of cosmetic issues, 
                including discoloration, chips, cracks, gaps, uneven shape, and worn-down teeth. Veneers 
                are made from porcelain or composite resin and are a long-lasting solution for enhancing a Smile
                </p>
                <h2>Pricing</h2>
                <table className="veneers-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};

export default Veneers;